import { FundingRound } from 'entities-next/fundingRounds'
import TrashIcon from 'mdi-react/TrashIcon'
import React from 'react'
import { FormContainer } from 'scenes/Dashboard/components-next/Forms'
import { makeStyles } from 'tss-react/mui'
import { FormHelpers, FormManager } from 'utils-next/forms'
import { ExtendableStyles, Testable } from 'utils-next/types'

import { Button, IconButton } from '@mui/material'

import {
  FundingRoundFormData,
  getFundingRoundValidation,
  parseFormFundingRound,
  parseFundingRoundToFormData,
} from './FundingRoundForm.data'
import { FundingRoundFormContent } from './FundingRoundFormContent.component'

export type FundingRoundFormProps = ExtendableStyles &
  Testable & {
    data: FundingRound
    onUpdate: (data: FundingRound) => Promise<any> | any
    onDelete: () => any
  }

export function FundingRoundForm({ onUpdate, onDelete, data, ...otherProps }: FundingRoundFormProps) {
  const { classes } = useStyles()
  const initialValues = parseFundingRoundToFormData(data)

  const handleSubmit = async (data: FundingRoundFormData, { setSubmitting }: FormHelpers<FundingRoundFormData>) => {
    setSubmitting(true)
    const fundingRoundData = parseFormFundingRound(data)
    await onUpdate(fundingRoundData)
    setSubmitting(false)
  }

  return (
    <FormManager<FundingRoundFormData>
      initialValues={initialValues}
      validateOnBlur={false}
      validateOnChange={false}
      validationSchema={getFundingRoundValidation()}
      onSubmit={handleSubmit}
      enableReinitialize
    >
      {(formProps) => (
        <FormContainer disabled={formProps.isSubmitting} onSubmit={formProps.handleSubmit} {...otherProps}>
          <FundingRoundFormContent className={classes.content} {...formProps} />

          <div className={classes.actions}>
            <IconButton className={classes.actionButtons} aria-label="delete" onClick={onDelete}>
              <TrashIcon />
            </IconButton>

            <Button
              variant="outlined"
              className={classes.actionButtons}
              onClick={formProps.submitForm}
              aria-label="submit"
            >
              Save
            </Button>
          </div>
        </FormContainer>
      )}
    </FormManager>
  )
}

const useStyles = makeStyles()(({ spacing }) => ({
  content: {
    width: '100%',
    marginBottom: spacing(3),
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  actionButtons: {
    marginLeft: spacing(2),
  },
}))
